import { render, staticRenderFns } from "./profileProductsList.vue?vue&type=template&id=388b6b55&"
import script from "./profileProductsList.vue?vue&type=script&lang=js&"
export * from "./profileProductsList.vue?vue&type=script&lang=js&"
import style0 from "./profileProductsList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports